// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EntityPropertySelectionRegionTimelineBuf } from '../entity/entity-property-selection-region-timeline-buf.js';


/**
 * We include a request object that can be sent to request the 
 * properties in a given way. For example, for timestamp-based meta-
 * properties, we can request a range with a max number of properties.
 * In the future, perhaps other kinds of properties could have different
 * kinds of requests. For example, we could have a request for "2-D" 
 * properties if we want geographically mapped properties, or if
 * we want to create an "infinite canvas" of files, we create a 2D 
 * metaproperty for folders that lets us request files in a given area.
 */
export class EntityPropertySelectionRegionBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EntityPropertySelectionRegionBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEntityPropertySelectionRegionBuf(bb:flatbuffers.ByteBuffer, obj?:EntityPropertySelectionRegionBuf):EntityPropertySelectionRegionBuf {
  return (obj || new EntityPropertySelectionRegionBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEntityPropertySelectionRegionBuf(bb:flatbuffers.ByteBuffer, obj?:EntityPropertySelectionRegionBuf):EntityPropertySelectionRegionBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EntityPropertySelectionRegionBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

timeline(obj?:EntityPropertySelectionRegionTimelineBuf):EntityPropertySelectionRegionTimelineBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new EntityPropertySelectionRegionTimelineBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startEntityPropertySelectionRegionBuf(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addTimeline(builder:flatbuffers.Builder, timelineOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, timelineOffset, 0);
}

static endEntityPropertySelectionRegionBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEntityPropertySelectionRegionBuf(builder:flatbuffers.Builder, timelineOffset:flatbuffers.Offset):flatbuffers.Offset {
  EntityPropertySelectionRegionBuf.startEntityPropertySelectionRegionBuf(builder);
  EntityPropertySelectionRegionBuf.addTimeline(builder, timelineOffset);
  return EntityPropertySelectionRegionBuf.endEntityPropertySelectionRegionBuf(builder);
}
}
